import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Truck02 = function Truck02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 16V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 3 13.9201 3 12.8 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16zm0 0h4.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C22 15.2401 22 14.9601 22 14.4v-2.7373c0-.2445 0-.3668-.0276-.4819a1 1 0 0 0-.1198-.2891c-.0618-.1009-.1483-.1874-.3212-.3603l-2.0628-2.0628c-.1729-.173-.2594-.2594-.3603-.3212a1 1 0 0 0-.2891-.1198C18.7041 8 18.5818 8 18.3373 8H16M9 18.5C9 19.8807 7.8807 21 6.5 21S4 19.8807 4 18.5 5.1193 16 6.5 16 9 17.1193 9 18.5m11 0c0 1.3807-1.1193 2.5-2.5 2.5S15 19.8807 15 18.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5"
    })
  }));
};
export default Truck02;